export default class UserPhoneConfirmBan {
    Id: number = 0;
    DateOfBan?: Date;
    ExpireDate?: Date;
}